/**
 * RoadwaysToolbarContent - Herramientas del módulo Vialidades
 *
 * @version 1.0
 * @created 2026-02-27
 * @module roadways/components
 *
 * @description
 * Contenido de la sección modular del BottomToolbar para el módulo Roadways.
 * Se renderiza cuando el módulo vialidades está activo.
 *
 * @remarks
 * Implementa la interfaz ModuleToolbarProps para integrarse con el module-registry.
 * Las herramientas disponibles dependen del modo operacional activo.
 */

import { Route, Construction } from 'lucide-react';
import type { ModuleToolbarProps } from '../../../module-registry';
import { useOperationalModeStore } from '../../../operational-modes';

/**
 * Contenido del toolbar para el módulo Roadways
 *
 * @remarks
 * Renderiza una fila con las herramientas activas del módulo.
 * Solo las herramientas de creación están habilitadas en modo 'inventory'.
 */
export function RoadwaysToolbarContent({
  activeTool,
  onToolChange,
}: ModuleToolbarProps): JSX.Element {
  const { mode } = useOperationalModeStore();
  const isInventoryMode = mode === 'inventory';

  const handleToolClick = (toolId: string, event: React.MouseEvent<HTMLButtonElement>): void => {
    const newTool = activeTool === toolId ? null : toolId;
    void onToolChange(newTool);

    // Quitar foco del botón para que eventos keyboard (ESC) vayan al document
    event.currentTarget.blur();
  };

  return (
    <div className="toolbar-row">
      {/* Botón 1: Crear Segmento Vial */}
      <button
        className={`toolbar-square-btn ${activeTool === 'create-road-segment' ? 'active' : ''}`}
        aria-label="Crear segmento vial"
        title={!isInventoryMode ? 'Debes estar en modo Inventariar para crear elementos' : 'Crear segmento vial'}
        onClick={(e) => handleToolClick('create-road-segment', e)}
        disabled={!isInventoryMode}
      >
        <Route size={20} />
      </button>

      {/* Botón 2: Reportar Defecto Vial */}
      <button
        className={`toolbar-square-btn ${activeTool === 'create-road-defect' ? 'active' : ''}`}
        aria-label="Reportar defecto vial"
        title={!isInventoryMode ? 'Debes estar en modo Inventariar para crear elementos' : 'Reportar defecto vial (bache, grieta, etc.)'}
        onClick={(e) => handleToolClick('create-road-defect', e)}
        disabled={!isInventoryMode}
      >
        <Construction size={20} />
      </button>
    </div>
  );
}
